/**
  * @class meleMap_lib
  * @description
  *
  * # Purpose
  * Shared methods
  *
  * # Use
  *
  * # Implementation notes
  *
  */

require('leaflet')

const geohash = require('ngeohash')
const GEOHASH_PRECISION = 12
const DEFAULT_CENTER = 'u2s1yh4mkbre'
const DEFAULT_PANE = 'mosy'
const SEARCH_PANE = 'mosy-search'
const DRAW_PANE = 'mosy-draw'
const TYPE_SHAPE_ATTRIBUTES = {
  unit: { status: '{status}' },
  instruction: { time: 'some:{time}' },
}

////////////////////////////////////////////////////////////////////////////////////////////////////
/**
* Converts geohash to [lat,lng]
*/
function geohash2point(geo_hash) {
  let data = []
  if(Array.isArray(geo_hash)) {
    geo_hash.forEach(geo=>{
      data.push(_.toArray(_.omit(geohash.decode(geo), 'error')))
    })
  } else {
    data = _.toArray(_.omit(geohash.decode(geo_hash), 'error'))
  }
  return (data)
} // geohash2point

////////////////////////////////////////////////////////////////////////////////////////////////////
/**
* Converts [lat,lng] or {lat:...,lng:...} to geohash
*/
function point2geohash(lat_lng, precision) {
  let lat, lng
  if (Array.isArray(lat_lng) && lat_lng.length == 2) {
    lat = parseFloat(lat_lng[0])
    lng = parseFloat(lat_lng[1])
  } else if (_.isObjectLike(lat_lng)) {
    lat = parseFloat(lat_lng.lat)
    lng = parseFloat(lat_lng.lng)
  }
  if (isNaN(lat) || isNaN(lng)) return ''
  return geohash.encode(lat, lng, precision || GEOHASH_PRECISION)
} // point2geohash

function degToRad(d) {
  return d * Math.PI / 180
}
function radToDeg(r) {
  return r * 180 / Math.PI
}
function intermediatePoint(latlng1, latlng2, f) {
  if(!Array.isArray(latlng1)) latlng1 = [latlng1.lat, latlng1.lng]
  if(!Array.isArray(latlng2)) latlng2 = [latlng2.lat, latlng2.lng]
  const lat1=degToRad(latlng1[0])
  const lng1=degToRad(latlng1[1])
  const lat2=degToRad(latlng2[0])
  const lng2=degToRad(latlng2[1])
  const d = 2 * Math.asin(
    Math.sqrt(Math.pow((Math.sin((lat1 - lat2) / 2)),
      2) +
            Math.cos(lat1) * Math.cos(lat2) *
            Math.pow(Math.sin((lng1-lng2) / 2), 2)))
  const A = Math.sin((1 - f) * d) / Math.sin(d)
  const B = Math.sin(f * d) / Math.sin(d)
  const x = A * Math.cos(lat1) * Math.cos(lng1) + B *
      Math.cos(lat2) * Math.cos(lng2)
  const y = A * Math.cos(lat1) * Math.sin(lng1) + B *
      Math.cos(lat2) * Math.sin(lng2)
  const z = A * Math.sin(lat1) + B * Math.sin(lat2)
  const lat = Math.atan2(z, Math.sqrt(Math.pow(x, 2) +
        Math.pow(y, 2)))
  const lng = Math.atan2(y, x)

  return([radToDeg(lat), radToDeg(lng)])
}

module.exports = {
  geohash2point,
  point2geohash,
  DEFAULT_CENTER,
  DEFAULT_PANE,
  SEARCH_PANE,
  DRAW_PANE,
  TYPE_SHAPE_ATTRIBUTES,
  intermediatePoint,
}
